import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "213",
  height: "108"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "linearGradient-auto",
        x1: "-8.373%",
        x2: "336.355%",
        y1: "108.166%",
        y2: "62.625%"
      }, [
        _createElementVNode("stop", {
          offset: "0%",
          "stop-color": "#D7D3F6",
          "stop-opacity": ".25"
        }),
        _createElementVNode("stop", {
          offset: "100%",
          "stop-color": "#B1D9ED"
        })
      ])
    ], -1),
    _createElementVNode("path", {
      fill: "url(#linearGradient-auto)",
      "fill-rule": "evenodd",
      d: "M75.115 108c33.211-32.183 78.475-52 128.373-52q4.78 0 9.5.24V6.208a238 238 0 0 0-9.5-.208C123.15 6 52.259 46.408 10 108z"
    }, null, -1)
  ])))
}
export default { render: render }